<template>

  <!-- New / search refSheet -->
  <div class="row gap-08 w-full">
    <dropdownBox v-model="dropd" openOn='searchReferenceSheet' class="mleft-auto">
      <button-group styles="pad-s border-l" class="psides-06">
        <svg-item icon="search" styles="main-m " class="mtop-02" style="margin-top: 0.15rem;"/>
        <text-item :txt="t('refSheet.title')" styles="font-mBold main-m" class="mleft-03"/>
      </button-group>
      <template #dropd>
        <div style="width: 28rem; height: 21rem;" class="bg-modal" @click.stop>
          <text-item :txt="t('refSheet.searchRefSheet')" styles="font-mBold main-m" class="mleft-02"/>
          <searchRefSheet :autofocus="true" @afterSelect="closeFct()" @afterCreateNew="closeAndUpdateFct()"/>
        </div>
      </template>
    </dropdownBox>      

  </div>

  <!-- Current RefSheet -->
  <template v-if="reference">
    <div class="mtop-04">

      <!-- Title -->
      <dropdownBox v-model="dropd" openOn='editRefSheet'>
        <button-group theme="dropdown" style="margin-left: -0.35rem;">
          <svg-item icon="bookOpen" styles="main-h size-l" class="mleft-01 mtop-04"/>
          <text-item :txt="refSheetTitle" styles="font-l" class="mleft-05"/>
        </button-group>
        <template #dropd>
          <editRefSheet :refSheet="reference" @updateClose="closeAndUpdateFct()" @update="updateFct()"/>
        </template>
      </dropdownBox>
      <div class="mtop-02"></div>

      <!-- Tabs -->
      <div class="row gap-04">
        <div style="position: relative">
          <buttonGroup styles="pad-s" @click="changeCurrentTab('Sheet')">
            <text-item :txt="t('refSheet.title')" styles="main-h font-m"/>
          </buttonGroup>
          <div v-if="currentTab === 'Sheet'" class="w-full line-h" style="position: absolute; margin-top: -2px; border-top-width: 3px; border-color: var(--main-l);"/>
        </div>
        <div style="position: relative">
          <buttonGroup styles="pad-s" @click="changeCurrentTab('Presentation')">
            <text-item :txt="t('refSheet.tabs.Presentation')" styles="main-h font-m"/>
          </buttonGroup>
          <div v-if="currentTab === 'Presentation'" class="w-full line-h" style="position: absolute; margin-top: -2px; border-top-width: 3px; border-color: var(--main-l);"/>
        </div>
        <div style="position: relative">
          <buttonGroup styles="pad-s" @click="changeCurrentTab('Etio')">
            <text-item :txt="t('refSheet.tabs.Etio')" styles="main-h font-m"/>
          </buttonGroup>
          <div v-if="currentTab === 'Etio'" class="w-full line-h" style="position: absolute; margin-top: -2px; border-top-width: 3px; border-color: var(--main-l);"/>
        </div>
        <div style="position: relative">
          <buttonGroup styles="pad-s" @click="changeCurrentTab('Complic')">
            <text-item :txt="t('refSheet.tabs.Complic')" styles="main-h font-m"/>
          </buttonGroup>
          <div v-if="currentTab === 'Complic'" class="w-full line-h" style="position: absolute; margin-top: -2px; border-top-width: 3px; border-color: var(--main-l);"/>
        </div>
        <div style="position: relative">
          <buttonGroup styles="pad-s" @click="changeCurrentTab('Treatment')">
            <text-item :txt="t('refSheet.tabs.Treatment')" styles="main-h font-m"/>
          </buttonGroup>
          <div v-if="currentTab === 'Treatment'" class="w-full line-h" style="position: absolute; margin-top: -2px; border-top-width: 3px; border-color: var(--main-l);"/>
        </div>
        <div style="position: relative">
          <buttonGroup styles="pad-s" @click="changeCurrentTab('Invoice')">
            <text-item :txt="t('refSheet.tabs.Invoice')" styles="main-h font-m"/>
          </buttonGroup>
          <div v-if="currentTab === 'Invoice'" class="w-full line-h" style="position: absolute; margin-top: -2px; border-top-width: 3px; border-color: var(--main-l);"/>
        </div>
      </div>
      <div class="mtop-10"></div>
    </div>

    <!-- InputBoxes -->
    <div class="col gap-20" style="margin-top: 2rem;">

      <!-- Fiche -->
      <template v-if="currentTab === 'Sheet'">
        <!-- Triggers -->
        <div class="w-full">
          <text-item :txt="t('refSheet.names')" styles="font-mBold main-l"/>
          <inputBox class="pad-s mtop-02 w-full">
            <inputAreaAuto2 v-model="reference.triggers" @blur="updateReferenceText('Triggers', reference.triggers)"/>
          </inputBox>
        </div>
        <!-- reference files -->
        <div class="w-full">
          <div class="row">
            <text-item :txt="t('refSheet.referenceFile.list')" styles="font-mBold main-l"/>
            <file-upload id="entryRefFiles" multiple @filesChanged="entryFilesChangedRefSheet">
              <button-group>
                <svg-item icon="plus" styles="main-l"/>
              </button-group>
            </file-upload>
          </div>
          <template v-for="(referenceFile, index) in reference.referenceFiles" :key="index">
            <div class="row">
              <button-group style="padding-top: 0.1rem; padding-bottom: 0.1rem;" @click="showInternalRef(referenceFile)">
                <svg-item icon="file" styles="main-m size-s"/>
                <text-item class="mleft-04" :txt="referenceFile.title" style="max-width: 20rem;"/>
              </button-group>
              <dropdownBox v-model="dropd" :openOn="'editRefFile' + referenceFile.appUserResultReferenceFileId">
                <button-group>
                  <svg-item icon="moreVertical" styles="main-m" style="margin-top: -0.2rem;"/>
                </button-group>
                <template #dropd>
                  <editRefFile :refFile="referenceFile" @updateClose="closeAndUpdateFct" @update="updateFct"/>
                </template>
              </dropdownBox>
            </div>
          </template>
        </div>
        <!-- reference links -->
        <div>
          <div class="row">
            <text-item :txt="t('refSheet.referenceLink.list')" styles="font-mBold main-l"/>
            <dropdownBox v-model="dropd" openOn='addExternalLink'>
              <button-group>
                <svg-item icon="plus" styles="main-l"/>
              </button-group>
              <template #dropd>
                <addExternalLink :referenceSheet="reference" @updateClose="closeAndUpdateFct()"/>
              </template>
            </dropdownBox>
          </div>
          <template v-for="(externalLink, index) in externalLinks" :key="index">
            <div class="row">
              <button-group style="padding-top: 0.1rem; padding-bottom: 0.1rem;" @click="showExternalRef(externalLink.link)">
                <div v-if="externalLink.logoImage" class="item-s" style="margin-top: 0.1rem;">
                  <img :src="externalLink.logoImage" alt="Logo" style="width: 100%; height: 100%;">
                </div>
                <div v-else>
                  <svg-item icon="globe" styles="main-m size-s"/>
                </div>
                <text-item class="mleft-04" :txt="externalLink.linkTitle" style="max-width: 20rem;"/>
              </button-group>
              <dropdownBox v-model="dropd" :openOn="'editExternalLink' + index">
                <button-group>
                  <svg-item icon="moreVertical" styles="main-m" style="margin-top: -0.2rem;"/>
                </button-group>
                <template #dropd>
                  <editExternalLink :editedLink="externalLink" @updateClose="closeAndUpdateFct" @update="updateFct"/>
                </template>
              </dropdownBox>
            </div>
          </template>
        </div>
      </template>

      <!-- Tableau -->
      <template v-if="currentTab === 'Presentation'">
        <div class="w-full">
          <text-item :txt="t('refSheet.assessment.signs')" styles="font-mBold main-l"/>
          <inputBox class="pad-s mtop-02 w-full">
            <inputAreaAuto2 :lines=7 v-model="reference.presentation0" @blur="updateReferenceText('Presentation0', reference.presentation0)"/>
          </inputBox>
        </div>
        <div class="w-full">
          <text-item :txt="t('refSheet.assessment.prescriptionsFirst')" styles="font-mBold main-l"/>
          <inputBox class="pad-s mtop-02 w-full">
            <inputAreaAuto2 :lines=7 v-model="reference.presentation1" @blur="updateReferenceTextAndReload('Presentation1', reference.presentation1)"/>
          </inputBox>
        </div>
        <div class="w-full">
          <text-item :txt="t('refSheet.assessment.prescriptionsSecond')" styles="font-mBold main-l"/>
          <inputBox class="pad-s mtop-02 w-full">
            <inputAreaAuto2 :lines=7 v-model="reference.presentation2" @blur="updateReferenceTextAndReload('Presentation2', reference.presentation2)"/>
          </inputBox>
        </div>
      </template>

      <!-- Etio -->
      <template v-if="currentTab === 'Etio'">
        <div class="w-full">
          <text-item :txt="t('refSheet.assessment.signs')" styles="font-mBold main-l"/>
          <inputBox class="pad-s mtop-02 w-full">
            <inputAreaAuto2 :lines=7 v-model="reference.etio0" @blur="updateReferenceText('Etio0', reference.etio0)"/>
          </inputBox>
        </div>
        <div class="w-full">
          <text-item :txt="t('refSheet.assessment.prescriptionsFirst')" styles="font-mBold main-l"/>
          <inputBox class="pad-s mtop-02 w-full">
            <inputAreaAuto2 :lines=7 v-model="reference.etio1" @blur="updateReferenceTextAndReload('Etio1', reference.etio1)"/>
          </inputBox>
        </div>
        <div class="w-full">
          <text-item :txt="t('refSheet.assessment.prescriptionsSecond')" styles="font-mBold main-l"/>
          <inputBox class="pad-s mtop-02 w-full">
            <inputAreaAuto2 :lines=7 v-model="reference.etio2" @blur="updateReferenceTextAndReload('Etio2', reference.etio2)"/>
          </inputBox>
        </div>
      </template>

      <!-- Complic -->
      <template v-if="currentTab === 'Complic'">
        <div class="w-full">
          <text-item :txt="t('refSheet.assessment.signs')" styles="font-mBold main-l"/>
          <inputBox class="pad-s mtop-02 w-full">
            <inputAreaAuto2 :lines=7 v-model="reference.complic0" @blur="updateReferenceText('Complic0', reference.complic0)"/>
          </inputBox>
        </div>
        <div class="w-full">
          <text-item :txt="t('refSheet.assessment.prescriptionsFirst')" styles="font-mBold main-l"/>
          <inputBox class="pad-s mtop-02 w-full">
            <inputAreaAuto2 :lines=7 v-model="reference.complic1" @blur="updateReferenceTextAndReload('Complic1', reference.complic1)"/>
          </inputBox>
        </div>
        <div class="w-full">
          <text-item :txt="t('refSheet.assessment.prescriptionsSecond')" styles="font-mBold main-l"/>
          <inputBox class="pad-s mtop-02 w-full">
            <inputAreaAuto2 :lines=7 v-model="reference.complic2" @blur="updateReferenceTextAndReload('Complic2', reference.complic2)"/>
          </inputBox>
        </div>
      </template>

      <!-- Treatment -->
      <template v-if="currentTab === 'Treatment'">
        <div class="w-full">
          <text-item :txt="t('refSheet.treatment.medication')" styles="font-mBold main-l"/>
          <inputBox class="pad-s mtop-02 w-full">
            <inputAreaAuto2 :lines=7 v-model="reference.medication" @blur="updateReferenceTextAndReload('Medication', reference.medication)"/>
          </inputBox>
        </div>
        <div class="w-full">
          <text-item :txt="t('refSheet.treatment.healthPro')" styles="font-mBold main-l"/>
          <inputBox class="pad-s mtop-02 w-full">
            <inputAreaAuto2 v-model="reference.healthPro" @blur="updateReferenceTextAndReload('HealthPro', reference.healthPro)"/>
          </inputBox>
        </div>
        <div class="w-full">
          <text-item :txt="t('refSheet.treatment.administratif')" styles="font-mBold main-l"/>
          <inputBox class="pad-s mtop-02 w-full">
            <inputAreaAuto2 v-model="reference.administrative" @blur="updateReferenceTextAndReload('Administrative', reference.administrative)"/>
          </inputBox>
        </div>
        <div class="w-full">
          <text-item :txt="t('refSheet.referenceDocument.list')" styles="font-mBold main-l"/>
          <div class="mtop-02">
            <template v-for="referenceDocument in Object.values(reference.referenceDocuments).flat()" :key="referenceDocument.id">
              <div class="row">
                <template v-if="allowRefDocumentCreation">
                  <button-group style="padding-top: 0.1rem; padding-bottom: 0.1rem;" @click="prescribeFromReferenceDoc(referenceDocument)">
                    <svg-item icon="file" styles="main-m size-s"/>
                    <text-item class="mleft-04" :txt="referenceDocument.title" style="max-width: 20rem;"/>
                  </button-group>
                </template>
                <template v-else>
                  <text-item class="mleft-02" :txt="referenceDocument.title" style="max-width: 20rem;"/>
                </template>
                <dropdownBox v-model="dropd" :openOn="'editReferenceDocument' + referenceDocument.id">
                  <button-group>
                    <svg-item icon="moreVertical" styles="main-m" style="margin-top: -0.2rem;"/>
                  </button-group>
                  <template #dropd>
                    <editRefDocument :referenceDocument="referenceDocument" @updateClose="closeAndUpdateFct" @update="updateFct"/>                    
                  </template>
                </dropdownBox>
              </div>
            </template>
          </div>

        </div>        
        <!-- PatientFiles -->
        <div class="w-full">
          <div class="row">
            <text-item :txt="t('refSheet.patientFile.list')" styles="font-mBold main-l"/>
            <file-upload id="patientEntryFiles" multiple @filesChanged="patientEntryFilesChangedFCT">
              <button-group>
                <svg-item icon="plus" styles="main-l"/>
              </button-group>
            </file-upload>
          </div>
          <template v-for="(referenceFile, index) in reference.patientFiles" :key="index">
            <div class="row">
              <button-group style="padding-top: 0.1rem; padding-bottom: 0.1rem;" @click="showInternalRef(referenceFile)">
                <svg-item icon="file" styles="main-m size-s"/>
                <text-item class="mleft-04" :txt="referenceFile.title" style="max-width: 20rem;"/>
              </button-group>
              <dropdownBox v-model="dropd" :openOn="'editPatientFile' + referenceFile.appUserResultReferenceFileId">
                <button-group>
                  <svg-item icon="moreVertical" styles="main-m" style="margin-top: -0.2rem;"/>
                </button-group>
                <template #dropd>
                  <editRefFile :refFile="referenceFile" @updateClose="closeAndUpdateFct()" @update="updateFct()"/>
                </template>
              </dropdownBox>
            </div>
          </template>
        </div>
      </template>

      <!-- Invoice -->
      <template v-if="currentTab === 'Invoice'">
        <div class="w-full">
          <text-item :txt="t('refSheet.invoice.billingCodes')" styles="font-mBold main-l"/>
          <inputBox class="pad-s mtop-02 w-full">
            <inputAreaAuto2 v-model="reference.invoice" @blur="updateReferenceText('Invoice', reference.invoice)"/>
          </inputBox>
        </div>
      </template>
    </div>

  </template>
</template>




<script setup>
import addExternalLink from './addExternalLink.vue'
import editExternalLink from './editExternalLink.vue'
import editRefDocument from './editRefDocument.vue'
import searchRefSheet from './searchRefSheet.vue'
import editRefFile from './editRefFile.vue'
import editRefSheet from './editRefSheet.vue'

import { ref, computed, onBeforeUnmount } from 'vue'
import { useUiStore } from '@/stores/ui'
import { getSearchEngineLogo }  from '@/functions/externalReference'
import { createReferenceSheetTitle } from "@/functions/resultSuggestion.js"
import { useCurrentEntryStore } from '@/stores/currentEntry'
import appuserapi from "@/api/appuserapi"
import { useI18n } from "vue-i18n";
import patientapi from "@/api/patientapi"
import { useRoute } from 'vue-router';
const route = useRoute()

const { t } = useI18n();
const uiStore = useUiStore()
const currentEntryStore = useCurrentEntryStore()

const dropd = ref(null)
let isReload = false


function closeFct() {
  dropd.value = ''
}

async function updateFct(updatePromise) {
  if (updatePromise) await updatePromise;
  await updateRefSheet();
  await fullReload();
}
async function closeAndUpdateFct(deletePromise) {
  dropd.value = '';
  if (deletePromise) await deletePromise;
  await updateRefSheet();
  await fullReload();
}

const allowRefDocumentCreation = computed(() => {
  if (route.name !== 'patient') return false;
  if (!currentEntryStore.isEditable) return false;
  return true;
})

async function prescribeFromReferenceDoc(referenceDocument) {
  if (!allowRefDocumentCreation.value) return;
  const refSheet = uiStore.currRefSheet;
  const entryId = currentEntryStore.currentEntryId;
  const cclId = currentEntryStore.currentCcl?.conclusionGroupId.toString() || null;
  const referenceDocumentId = referenceDocument.id;
  uiStore.setModalUiId("");  
  currentEntryStore.setMiddleTab('docTemplate')
  currentEntryStore.emptyCurrentDoc()
  const newPatientDocument = await patientapi.addReferenceTemplateToCcl(entryId, cclId, referenceDocumentId)
  const fullReferenceDocument = await appuserapi.getReferenceDocument(referenceDocumentId);
  currentEntryStore.setCurrentDoc(newPatientDocument);
  currentEntryStore.setMiddleRefSheet(refSheet);
  currentEntryStore.setMiddleReferenceDocument(fullReferenceDocument)
  currentEntryStore.reloadCurrentEntry();
}

async function patientEntryFilesChangedFCT(files) {
  const refSheetId = reference.value.appUserResultReferenceId.toString()
  await appuserapi.addPatientFilesToRefSheet(refSheetId, files)
  updateRefSheet()
  fullReload()
}

async function entryFilesChangedRefSheet(files) {
  const refSheetId = reference.value.appUserResultReferenceId.toString()
  await appuserapi.addFilesToRefSheet(refSheetId, files)
  updateRefSheet()
  fullReload()
}

async function updateRefSheet() {
  isReload = true
  const refSheetId = uiStore.currRefSheet?.appUserResultReferenceId
  const updatedRefSheet = await appuserapi.getRefSheet(refSheetId)
  uiStore.setCurrRefSheet(updatedRefSheet)
}


async function fullReload() {
  if (!isReload) return;
  const currCclId = currentEntryStore.currentCcl?.conclusionGroupId
  const expressionType = uiStore.dashBoardItem?.expressionType
  const expressionId = uiStore.dashBoardItem?.expressionId
  if (currCclId) {
    await currentEntryStore.updateCclSuggestionsForResults(currCclId)
  } else if (expressionId && !["ResultDocument"].includes(expressionType)) {
    const refSheetSuggestions = await appuserapi.getRefSheetsForExpr(expressionId)
    currentEntryStore.setCurrCclSuggestionsFromResults(refSheetSuggestions)  
  }
}

const reference = computed(() => {
  return uiStore.currRefSheet || null
})

const externalLinks = computed(() => {
  const links = uiStore.currRefSheet.externalLinks
  if (!links) return []
  links.forEach(link => {
    link.logoImage = getSearchEngineLogo(link.link)
  })
  return links
})

const refSheetTitle = computed(() => {
  const refSheet = reference.value
  return (createReferenceSheetTitle(refSheet))
})

const currentTab = computed(() => {
  return uiStore.referenceTab
})

function changeCurrentTab(tabName) {
  uiStore.setReferenceTab(tabName)
}

function showExternalRef(link) {
  uiStore.setReferenceFile(null)
  uiStore.setReferenceIFramePath(link)
}

function showInternalRef(refFile) {
  uiStore.setReferenceIFramePath("")
  uiStore.setReferenceFile(refFile)
}

async function updateReferenceText(resultReferenceType, newText) {
  if (!reference.value) return
  const resultReferenceId = reference.value.appUserResultReferenceId
  await appuserapi.updateResultReferenceText(resultReferenceId, resultReferenceType, newText)
}

async function updateReferenceTextAndReload(resultReferenceType, newText){
  if (!reference.value) return
  const resultReferenceId = reference.value.appUserResultReferenceId
  await appuserapi.updateResultReferenceText(resultReferenceId, resultReferenceType, newText)
  updateRefSheet()
}

onBeforeUnmount(() => {
  fullReload()
})

</script>

<style scoped>
</style>